import React from 'react';
import {Container, Row, Col, Card} from 'react-bootstrap';
import FormRegister,{action} from '../components/FormRegister';
import ModalVerifyCode from '../components/ModalVerifyCode';
import { get_verify_code } from '../api';
import { useNavigate } from 'react-router-dom';

export const userRegister = action;
// export const verifyEmail = action;

function Register() {

    const navigate = useNavigate();

    const [modalShow, setModalShow] = React.useState(false);
    const [email,set_email] = React.useState("");
    const [await_time,set_await_time] = React.useState(0);

    const handle_onSuccess = (data) =>{
        
        set_email(data.email);

        get_verify_code(data.email).then((data)=> {

            set_await_time(data.await_time);
            setModalShow(true)
        })
        .catch((err)=>{
            console.log(err);
            // message(err.message)
        })
    }

    const handle_verifyCode = () =>{

        navigate(`/login?msg=registerSuccess`);
    }

  return (
    <Container>
        <Row className='justify-content-center mt-4'>
            <Col lg = "4" md="4">
                <Card style={{marginTop:"60px"}}>
                <Card.Title className='text-center mt-3'>Crear Cuenta</Card.Title>
                    <Card.Body>
                        <FormRegister onSuccess = { handle_onSuccess }/>
                    </Card.Body>
                </Card>
            </Col>
        </Row>

        <ModalVerifyCode 
                show        = { modalShow }
                email       = { email }
                await_time   = { await_time }
                onHide      = { () => setModalShow(false) }
                onSuccess   = { handle_verifyCode }
            />
    </Container>
  )
}

export default Register